import React, { useEffect, useRef, useState } from 'react';
import carPrice from '../../common/assets/images/priceChecker.svg';
import dealerPrice from '../../common/assets/images/dealerPrice.png';
import privacy from '../../common/assets/images/privacyCheck.svg';
import { marketValue } from '../../utils/api';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { LoadingOutlined } from '@ant-design/icons';
import {  Spin, Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import Column from 'antd/es/table/Column';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Price = ({ vin }) => {
  const navigate=useNavigate();
  const [detail, setDetails] = useState([]);
  const [outStandingPrice, setOutstandingPrice] = useState(0);
  const [roughPrice, setRoughPrice] = useState(0);
  const [cleanPrice, setCleanPrice] = useState(0);
  const [averagePrice, setAveragePrice] = useState(0);
  const [loading, setLoading] = useState(true);
  const chartRef = useRef(null);
  const config = {
    scales: {
      y: {
        min: 0, 
        max: outStandingPrice[0],
        ticks: {
          display: false,
        },
      }
    }
  };
  const labels = ["Dealer Retail", "Private Party", "Trade-In"]
  const roughData = {
    labels: labels,
    datasets: [
      {
        label: "Rough",
        data: roughPrice,
        backgroundColor: [
          'rgba(210, 43, 43 ,0.5)',
          'rgba(210, 43, 43 ,0.5)',
          'rgba(210, 43, 43 ,0.5)',
        ],
      },
    ],
  };
  const averageData = {
    labels: labels,
    datasets: [
      {
        label: "Average",
        data: averagePrice,
        backgroundColor: [
          'rgba(255, 205, 86, 0.5)',
          'rgba(255, 205, 86, 0.5)',
          'rgba(255, 205, 86, 0.5)',
        ],
      },
    ],
  };
  const cleanData = {
    labels: labels,
    datasets: [
      {
        label: "Clean",
        data: cleanPrice,
        backgroundColor: [
          'rgba(255, 117, 24, 0.5)',
          'rgba(255, 117, 24, 0.5)',
          'rgba(255, 117, 24, 0.5)',
        ],
      },
    ],
  };
  const outStandingData = {
    labels: labels,
    datasets: [
      {
        label: "Outstanding",
        data: outStandingPrice,
        backgroundColor: [
          'rgba(80, 200, 120, 0.5)',
          'rgba(80, 200, 120, 0.5)',
          'rgba(80, 200, 120, 0.5)',
        ],
      },
    ],
  };

  useEffect(() => {
    if (detail?.length) {
      let outStandingData = detail.filter((item) => item.Condition === "Outstanding")[0]
      let roughData = detail.filter((item) => item.Condition === "Rough")[0]
      let cleanData = detail.filter((item) => item.Condition === "Clean")[0]
      let averageData = detail.filter((item) => item.Condition === "Average")[0]
      setAveragePrice([+averageData["Dealer Retail"].split("$")[1].split(",").join(""), +averageData["Private Party"].split("$")[1].split(",").join(""), +averageData["Trade-In"].split("$")[1].split(",").join("")]);
      setCleanPrice([+cleanData["Dealer Retail"].split("$")[1].split(",").join(""), +cleanData["Private Party"].split("$")[1].split(",").join(""), +cleanData["Trade-In"].split("$")[1].split(",").join("")]);
      setOutstandingPrice([+outStandingData["Dealer Retail"].split("$")[1].split(",").join(""), +outStandingData["Private Party"].split("$")[1].split(",").join(""), +outStandingData["Trade-In"].split("$")[1].split(",").join("")]);
      setRoughPrice([+roughData["Dealer Retail"].split("$")[1].split(",").join(""), +roughData["Private Party"].split("$")[1].split(",").join(""), +roughData["Trade-In"].split("$")[1].split(",").join("")]);
    }
  }, [detail])
  useEffect(() => {
    if (chartRef.current) {
      const chart = chartRef.current;
      if (chart) {
        chart.canvas.parentNode.style.width = '280px';
      }
    }
  }, [chartRef]);
  useEffect(() => {
    setLoading(true);
    marketValue(vin)
      .then((res) => {
        setDetails(res?.data?.data?.market_value?.market_value_data[0]["market value"])
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [vin]);
  return (
    <Spin
      spinning={loading}
      indicator={
        <LoadingOutlined
          style={{
            fontSize: 48,
            color: 'black',
          }}
          spin
        />
      }
    >
      <div>
        <div className='bg-[#C1F0FB]'>
          <h2 className='container font-semibold text-3xl py-9'>Price</h2>
        </div>
        <div className='container py-[30px]'>
          <div className='flex gap-1 pb-5'>
            <img src={carPrice} alt='' />
            <p>Price Checker</p>
          </div>
          <p className='text-lg pb-[43px]'>
            Are you getting a good price? Check it before you buy
          </p>
          <div className='relative flex my-24'>
            <Bar ref={chartRef} className='barChart' data={roughData} options={config} />
            <Bar ref={chartRef} className='barChart' data={averageData} options={config} />
            <Bar ref={chartRef} className='barChart' data={cleanData} options={config} />
            <Bar ref={chartRef} className='barChart' data={outStandingData} options={config} />
          </div>
          <div>
            <Table dataSource={detail} rowKey="Condition" pagination={false}>
              <Column title="Condition" dataIndex="Condition" key="Condition" />
              <Column title="Trade-In" dataIndex="Trade-In" key="Trade-In" />
              <Column title="Private Party" dataIndex="Private Party" key="Private Party" />
              <Column title="Dealer Retail" dataIndex="Dealer Retail" key="Dealer Retail" />
            </Table>
          </div>
          {/* <p className='text-lg pb-6 pt-10'>
            considers this used vehicle a Great Price because the price is $3,973
            below market. 15% of the used inventory currently listed on Edmunds is
            a great price. Our ratings are accurate and up-to-date - we've
            analyzed thousands of similar transactions and listings to rate these
            deals.
          </p>
          <h4 className='font-semibold text-3xl'>
            Use this form to get the dealer's price quote.
          </h4>
          <div className='py-[35px] flex flex-wrap gap-3 pb-[31px]'>
            <div
              className='p-6 text-lg border-[0.5px] border-[#575757] min-w-[554px]'
              style={{ boxShadow: '1px 1px 11px 2px #0000002B' }}
            >
              <p>First Name</p>
              <p className='font-semibold'>Web</p>
            </div>
            <div
              className='p-6 text-lg border-[0.5px] border-[#575757] min-w-[554px]'
              style={{ boxShadow: '1px 1px 11px 2px #0000002B' }}
            >
              <p>Last Name</p>
              <p className='font-semibold'>Test</p>
            </div>
            <div
              className='p-6 text-lg border-[0.5px] border-[#575757] min-w-[554px]'
              style={{ boxShadow: '1px 1px 11px 2px #0000002B' }}
            >
              <p>Email</p>
              <p className='font-semibold'>example@gmail.com</p>
            </div>
            <div
              className='p-6 text-lg border-[0.5px] border-[#575757] min-w-[554px]'
              style={{ boxShadow: '1px 1px 11px 2px #0000002B' }}
            >
              <p>Phone </p>
            </div>
          </div> */}
          <div className='mt-16'>
            <button className='darkBlue px-[52px] py-[25px] text-white text-lg mb-[31px]' onClick={() => navigate(`/form_page/${vin}`)}>
              Generate PDF
            </button>
          </div>
          {/* <div className='flex gap-[14px]'>
            <img src={privacy} alt='' />
            <p className='text-lg underline'>
              This information will not be shared with any dealer other than those
              you select. Our collection and use of your personal information
            </p>
          </div> */}
        </div>
      </div>
    </Spin>
  );
};

export default Price;
